<div class="biz">
  <header class="biz-head">
    <div>
      <h1>Új bizonylat</h1>
      <p class="sub">Számla, díjbekérő vagy számviteli bizonylat kiállítása</p>
    </div>
  </header>

  <!-- E-számla / papír számla -->
  <div class="formatum">
    <div class="pill-seg">
      <button type="button" [class.on]="eszamla" (click)="eszamla = true"><ion-icon name="shield-checkmark-outline"></ion-icon> E-számla</button>
      <button type="button" [class.on]="!eszamla" (click)="eszamla = false"><ion-icon name="print-outline"></ion-icon> Papír számla</button>
    </div>
    <span class="formatum-sug">{{ eszamla ? 'A PDF-et az intézmény tanúsítványa elektronikusan, láthatóan aláírja.' : 'Nyomtatva adod át – a PDF nem kap elektronikus aláírást.' }}</span>
  </div>

  <!-- Bizonylattípus-választó -->
  <div class="doctypes">
    <button type="button" *ngFor="let b of bizonylatTipusok" class="dt"
      [class.on]="bizonylattipus === b.tipus" [class.szv]="b.tipus === 10" (click)="valasztTipus(b.tipus)">
      <ion-icon [name]="b.ikon"></ion-icon>
      <span class="dt-nev">{{ b.nev }}</span>
      <span class="dt-tag" *ngIf="b.nav">NAV</span>
    </button>
  </div>

  <div class="sheet">
    <!-- Felek -->
    <div class="parties">
      <div class="party">
        <div class="p-label">Kibocsátó</div>
        <div class="p-name">{{ szamlaprofil?.nev || sajatIntezmeny?.intezmenyName }}</div>
        <div class="p-line" *ngIf="szamlaprofil?.adoszam">Adószám: {{ szamlaprofil.adoszam }}</div>
        <div class="p-line" *ngIf="szamlaprofil?.irsz || szamlaprofil?.telepules">{{ szamlaprofil?.irsz }} {{ szamlaprofil?.telepules }}</div>
        <div class="p-line" *ngIf="szamlaprofil?.cim">{{ szamlaprofil?.cim }}</div>
        <div class="p-line muted" *ngIf="szamlaprofil?.bankszamla?.length">{{ szamlaprofil.bankszamla[0]?.bank }}: {{ szamlaprofil.bankszamla[0]?.szam }}</div>
      </div>

      <div class="party">
        <div class="p-label">Vevő</div>
        <div class="pill-seg">
          <button type="button" [class.on]="vevoMode === 'szulo'" (click)="vevoModeValt('szulo')">Szülő</button>
          <button type="button" [class.on]="vevoMode === 'partner'" (click)="vevoModeValt('partner')">Egyedi partner</button>
        </div>

        <!-- SZÜLŐ -->
        <div *ngIf="vevoMode === 'szulo'" class="vblock">
          <div class="combo">
            <input class="f" [(ngModel)]="szuloKeres" (focus)="szuloNyit = true"
              (input)="szuloNyit = true; valasztottSzulo = null" (blur)="szuloBlur()"
              placeholder="Szülő keresése…" autocomplete="off">
            <ion-icon class="combo-ic" name="chevron-down"></ion-icon>
            <div class="combo-pop" *ngIf="szuloNyit">
              <button type="button" class="combo-item" *ngFor="let s of szurtSzulok()" (click)="szuloValaszt(s)">
                <span class="ci-nev">{{ szuloCimke(s) }}</span>
                <small class="ci-sub" *ngIf="s.gyermekek?.length">
                  {{ s.gyermekek[0].full_name || s.gyermekek[0].name }}<span *ngIf="s.gyermekek[0].osztaly"> · {{ s.gyermekek[0].osztaly }}</span><span *ngIf="s.gyermekek.length > 1"> +{{ s.gyermekek.length - 1 }}</span>
                </small>
              </button>
              <div class="combo-empty" *ngIf="!szurtSzulok().length">Nincs találat</div>
            </div>
          </div>
          <div class="vdetail" *ngIf="valasztottSzulo">
            <div class="vd-line">{{ valasztottSzulo.irsz }} {{ valasztottSzulo.telepules }}<span *ngIf="valasztottSzulo.cim">, {{ valasztottSzulo.cim }}</span></div>
            <div class="gyerekek" *ngIf="valasztottSzulo.gyermekek?.length">
              <span class="gy-cimke">Gyermek:</span>
              <span class="gy-chip" *ngFor="let gy of valasztottSzulo.gyermekek">
                <ion-icon name="school-outline"></ion-icon>{{ gy.full_name || gy.name }}<span *ngIf="gy.osztaly"> · {{ gy.osztaly }}</span>
              </span>
            </div>
          </div>
        </div>

        <!-- PARTNER -->
        <div *ngIf="vevoMode === 'partner'" class="vblock">
          <div *ngIf="!ujPartnerNyit">
            <div class="combo">
              <input class="f" [(ngModel)]="partnerKeres" (focus)="partnerNyit = true"
                (input)="partnerNyit = true; valasztottPartner = null" (blur)="partnerBlur()"
                placeholder="Partner keresése…" autocomplete="off">
              <ion-icon class="combo-ic" name="chevron-down"></ion-icon>
              <div class="combo-pop" *ngIf="partnerNyit">
                <button type="button" class="combo-item" *ngFor="let p of szurtPartnerek()" (click)="partnerValaszt(p)">
                  <span class="ci-nev">{{ p.nev }}</span>
                  <small class="ci-sub">{{ p.adoszam ? p.adoszam + ' · ' : '' }}{{ p.telepules }}</small>
                </button>
                <div class="combo-empty" *ngIf="!szurtPartnerek().length">Nincs partner – hozz létre újat</div>
              </div>
            </div>
            <div class="vdetail" *ngIf="valasztottPartner">
              <div class="vd-line" *ngIf="valasztottPartner.adoszam">Adószám: {{ valasztottPartner.adoszam }}</div>
              <div class="vd-line">{{ valasztottPartner.irsz }} {{ valasztottPartner.telepules }}<span *ngIf="valasztottPartner.cim">, {{ valasztottPartner.cim }}</span></div>
            </div>
            <button type="button" class="link-btn" (click)="ujPartnerNyit = true; valasztottPartner = null; partnerKeres = ''">
              <ion-icon name="add"></ion-icon> Új partner
            </button>
          </div>

          <div *ngIf="ujPartnerNyit" class="uj-partner">
            <div class="field"><label>Partner neve *</label><input class="f" [(ngModel)]="ujPartner.nev"></div>
            <div class="grid2">
              <div class="field"><label>Adószám</label><input class="f" [(ngModel)]="ujPartner.adoszam"></div>
              <div class="field"><label>Adózás</label>
                <select class="f" [(ngModel)]="ujPartner.adozas">
                  <option [ngValue]="0">Adószámos</option>
                  <option [ngValue]="1">Magánszemély</option>
                  <option [ngValue]="2">Külföldi</option>
                </select>
              </div>
            </div>
            <div class="grid2">
              <div class="field w-sm"><label>Irsz.</label><input class="f" [(ngModel)]="ujPartner.irsz"></div>
              <div class="field"><label>Település</label><input class="f" [(ngModel)]="ujPartner.telepules"></div>
            </div>
            <div class="field"><label>Cím</label><input class="f" [(ngModel)]="ujPartner.cim"></div>
            <div class="field"><label>E-mail</label><input class="f" [(ngModel)]="ujPartner.email"></div>
            <div class="uj-partner-akciok">
              <button type="button" class="btn btn-primary sm" (click)="ujPartnerMent()"><ion-icon name="save-outline"></ion-icon> Mentés a törzsbe</button>
              <button type="button" class="btn btn-ghost sm" (click)="ujPartnerNyit = false; ujPartner = uresPartner()">Mégse</button>
            </div>
          </div>

          <div class="note" *ngIf="aktualisTipus()?.nav">
            <ion-icon name="information-circle-outline"></ion-icon>
            Egyedi partnernek a NAV-os számla most nem kerül beküldésre – használd a <b>Számviteli bizonylatot</b>.
          </div>
        </div>
      </div>
    </div>

    <!-- Meta -->
    <div class="meta">
      <div class="field"><label>Kelt</label><input class="f" type="date" [(ngModel)]="form.kelt"></div>
      <div class="field"><label>Teljesítés</label><input class="f" type="date" [(ngModel)]="form.teljesites"></div>
      <div class="field"><label>Fizetési határidő</label><input class="f" type="date" [(ngModel)]="form.hatarido"></div>
      <div class="field"><label>Fizetési mód</label>
        <select class="f" [(ngModel)]="form.fizmod">
          <option>Készpénz</option><option>Átutalás</option><option>Bankkártya</option><option>Online bankkártya</option><option>Egyéb</option>
        </select>
      </div>
      <div class="field"><label>Bizonylattömb (sorszám)</label>
        <select class="f" [(ngModel)]="form.biztomb">
          <option *ngFor="let t of valaszthatoTombok()" [ngValue]="t.id">{{ t.elotag }} — {{ t.nev }}</option>
        </select>
      </div>
      <div class="field w-sm"><label>Pénznem</label><input class="f" [value]="form.penznem" readonly></div>
    </div>

    <!-- Díjbekérő, fizetve, családi egyenleg -->
    <div class="kapcs">
      <div class="field" *ngIf="dijbekeroKell()">
        <label>Díjbekérő</label>
        <select class="f" [(ngModel)]="dijbekeroValasztas" (ngModelChange)="dijbekeroValt()" [disabled]="!valasztottSzulo">
          <option value="">— nincs —</option>
          <option *ngFor="let d of dijbekerok" [value]="d.id">{{ d.szamlaszam }} · {{ d.osszesen | currency:'HUF':'':'1.0-0' }} Ft{{ d.fizetve ? ' · fizetve' : '' }}</option>
          <option value="__kezi">Nincs a rendszerben – szám beírása…</option>
        </select>
        <small class="kapcs-sug" *ngIf="valasztottSzulo && !dijbekerok.length">A szülőnek nincs végszámla nélküli díjbekérője.</small>
      </div>
      <div class="field" *ngIf="dijbekeroKell() && dijbekeroValasztas === '__kezi'">
        <label>Díjbekérő száma</label>
        <input class="f" [(ngModel)]="dijbekeroKeziSzam" maxlength="60" placeholder="pl. ZENITDB-00904/2026">
      </div>
      <label class="pipa" *ngIf="fizetveKell()">
        <input type="checkbox" [(ngModel)]="fizetve" [disabled]="keszpenz()">
        <span>Már kifizetve{{ keszpenz() ? ' (készpénz: magától)' : '' }}</span>
      </label>
      <div class="field w-sm" *ngIf="fizetveKell() && fizetve && !keszpenz()">
        <label>Fizetés napja</label><input class="f" type="date" [(ngModel)]="fizetveDatum">
      </div>
      <label class="pipa" *ngIf="vevoMode === 'szulo'" [class.tiltva]="!!valasztottDijbekero()">
        <input type="checkbox" [(ngModel)]="csaladiEgyenleg" [disabled]="!!valasztottDijbekero()">
        <span>Családi egyenlegbe{{ valasztottDijbekero() ? ' (a díjbekérőé már ott van)' : (fizetve ? ' – kiírás és befizetés' : ' – kiírásként') }}</span>
      </label>
    </div>

    <!-- Tételek -->
    <div class="tetelek">
      <div class="t-head">
        <span class="c-nev">Megnevezés</span>
        <span class="c-ar">Br. egységár</span>
        <span class="c-afa">ÁFA</span>
        <span class="c-menny">Menny.</span>
        <span class="c-egys">M.e.</span>
        <span class="c-ossz">Összesen</span>
        <span class="c-x"></span>
      </div>
      <div class="t-row" *ngFor="let t of tetelek; let i = index">
        <input class="f c-nev" [(ngModel)]="t.nev" placeholder="Tétel megnevezése">
        <input class="f c-ar" type="number" [(ngModel)]="t.osszeg">
        <select class="f c-afa" [(ngModel)]="t.afa"><option *ngFor="let a of afaKulcsok" [value]="a">{{ a === 'AAM' || a === 'TAM' ? a : a + '%' }}</option></select>
        <input class="f c-menny" type="number" [(ngModel)]="t.mennyiseg">
        <input class="f c-egys" [(ngModel)]="t.megyseg">
        <span class="c-ossz osszeg">{{ t.osszeg | currency:'HUF':'':'1.0-0' }} Ft</span>
        <button type="button" class="t-del c-x" (click)="deleteTetel(i)"><ion-icon name="close"></ion-icon></button>
      </div>
      <div class="t-empty" *ngIf="!tetelek.length">Még nincs tétel.</div>
      <button type="button" class="uj-tetel" (click)="addTetel()"><ion-icon name="add"></ion-icon> Új tétel hozzáadása</button>

      <div class="t-osszeg">
        <span>Végösszeg</span>
        <b>{{ osszesen() | currency:'HUF':'':'1.0-0' }} Ft</b>
      </div>
    </div>

    <!-- Ellenőrzés visszajelzés -->
    <div class="hibak" *ngIf="ellenorizve && ellenorzesHibak.length">
      <div class="hibak-fej"><ion-icon name="alert-circle-outline"></ion-icon> A kitöltés hiányos</div>
      <ul><li *ngFor="let h of ellenorzesHibak">{{ h }}</li></ul>
    </div>
    <div class="ok-sav" *ngIf="ellenorizve && !ellenorzesHibak.length">
      <ion-icon name="checkmark-circle"></ion-icon> A bizonylat kitöltése rendben van.
    </div>
  </div>

  <div class="footer">
    <button type="button" class="btn btn-ghost" (click)="ellenoriz()"><ion-icon name="checkmark-circle-outline"></ion-icon> Ellenőrzés</button>
    <button type="button" class="btn btn-outline" (click)="elonezet()"><ion-icon name="eye-outline"></ion-icon> Előnézet</button>
    <button type="button" class="btn btn-primary" (click)="kiallit()" [disabled]="mentesFolyamat"><ion-icon name="document-attach-outline"></ion-icon> Kiállítás</button>
  </div>
</div>

<!-- Előnézet: a szerver a valódi PDF-generátorral rajzolja ki, mentés nélkül -->
<ion-modal #elonezetmodal class="elonezet-modal">
  <ng-template>
    <ion-header>
      <ion-toolbar>
        <ion-title>Bizonylat előnézet</ion-title>
        <ion-buttons slot="end"><ion-button (click)="elonezetZar()">Bezár</ion-button></ion-buttons>
      </ion-toolbar>
    </ion-header>
    <ion-content>
      <div class="elonezet-tolt" *ngIf="elonezetTolt">
        <ion-spinner></ion-spinner><p>Előnézet készítése…</p>
      </div>
      <iframe *ngIf="elonezetUrl" [src]="elonezetUrl" class="elonezet-iframe" title="Bizonylat előnézet"></iframe>
    </ion-content>
  </ng-template>
</ion-modal>
